module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Tables")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Table 1:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("Oligonucleotides used for Q-PCR")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("Table 2:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("Oligonucleotides used for Q-PCR")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686f0bc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/InteractTablesPage.vue
// module id = 1443
// module chunks = 1